namespace $.$$ {

	export class $shm_confirm_delete extends $.$shm_confirm_delete {

		@ $mol_action
		confirm_click( event?: Event | null ) {
			if( event === undefined ) return null
			this.confirmed( event )
			this.showed( false )
			return event
		}

		@ $mol_action
		cancel_click( event?: Event | null ) {
			if( event === undefined ) return null
			this.showed( false )
			return event
		}

	}

}
